"use client";

import { IUserMilestone } from "@faire/web-api--source/indigofair/data/IUserMilestone";

import {
  useMilestone,
  useMilestoneByDate,
  useRecordMilestoneOnce,
} from "./useMilestoneBase";

/**
 * Hook used to get/set the value of a retailer milestone for a user.
 *
 * NOTE: created_at and updated_at will be undefined if the milestone has not yet been recorded. This
 * change was made to standardize the behaviour with brand, and is different than the corresponding hook  in the retailer codebase.
 */
export const useRetailerMilestone = (
  milestoneType: IUserMilestone.RetailerMilestone
): ReturnType<typeof useMilestone<IUserMilestone.RetailerMilestone>> => {
  return useMilestone(false, milestoneType);
};

/**
 * Hook that returns a function to record a retailer milestone at most once per day.
 * If the milestone has been recorded less than a day (24 hours) ago, the function will not record it again.
 *
 * NOTE: created_at and updated_at will be undefined if the milestone has not yet been recorded. This
 * change was made to standardize the behaviour with brand, and is different than the corresponding hook  in the retailer codebase.
 */
export const useRetailerMilestoneByDate = (
  milestoneType: IUserMilestone.RetailerMilestone
): ReturnType<typeof useMilestoneByDate<IUserMilestone.RetailerMilestone>> => {
  return useMilestoneByDate(false, milestoneType);
};

/**
 * Hook that returns a function to record a retailer milestone at most once.
 * If the milestone has already been recorded, the function will not record it again.
 *
 * NOTE: created_at and updated_at will be undefined if the milestone has not yet been recorded. This
 * change was made to standardize the behaviour with brand, and is different than the corresponding hook  in the retailer codebase.
 */
export const useRetailerRecordMilestoneOnce = (
  milestoneType: IUserMilestone.RetailerMilestone
): ReturnType<
  typeof useRecordMilestoneOnce<IUserMilestone.RetailerMilestone>
> => {
  return useRecordMilestoneOnce(false, milestoneType);
};
